var idioma = $('html').attr('lang');
$('.houdiniForm').each(function() {//per cada formulari
    'use strict';
    //validacio formulari
    $(this).validate({
        errorPlacement: function(error, element) {
            if (element.attr('type') === 'checkbox' || element.attr('type') === 'radio') {
                if (element.closest('div').find('input').length > 1) {
                    error.insertAfter(element.closest('div').find('p.type-label'));
                } else {
                    error.insertAfter(element.parent('label'));
                }
            } else {
                error.insertAfter(element);
            }
        }
    });
});

//datapicker

$('.houdiniForm .hasDatepicker').fdatepicker({language: idioma});

$.dateRangePickerLanguages['ca'] =
{
	'selected': 'Període seleccionat:',
	'days': 'Dies',
	'apply': 'Aplicar',
	'week-1' : 'dl',
	'week-2' : 'dt',
	'week-3' : 'dc',
	'week-4' : 'dj',
	'week-5' : 'dv',
	'week-6' : 'ds',
	'week-7' : 'dg',
	'month-name': ['Gener','Febrer','Març','Abril','Maig','Juny','Juliol','Agost','Setembre','Octubre','Novembre','Desembre'],
	'shortcuts' : 'Shortcuts',
	'past': 'Past',
	'7days' : '7days',
	'14days' : '14days',
	'30days' : '30days',
	'previous' : 'Previous',
	'prev-week' : 'Week',
	'prev-month' : 'Month',
	'prev-quarter' : 'Quarter',
	'prev-year' : 'Any',
	'less-than' : 'Date range should longer than %d days',
	'more-than' : 'Date range should less than %d days',
	'default-more' : 'Please select a date range longer than %d days',
	'default-less' : 'Please select a date range less than %d days',
	'default-range' : 'Please select a date range between %d and %d days',
	'default-default': 'Selecciona un rang de dates'
};
if ($('.houdiniForm .hasDateRangepicker').length) {
$('.houdiniForm .hasDateRangepicker').dateRangePicker({
// 	showTopbar: false,
	separator : ' al ',
	format: 'DD/MM/YYYY',
	endDate: moment().endOf('day').format('DD/MM/YYYY'),
	autoClose: true,
	startOfWeek: 'monday',
	language: 'ca',
	showShortcuts: true,
	shortcuts : null,
	customShortcuts:
	[
		//if return an array of two dates, it will select the date range between the two dates
		{
			name: 'Avui',
			dates : function()
			{
				var start = moment().toDate();
				return [start,start];
			}
		},
		//if return an array of two dates, it will select the date range between the two dates
		{
			name: 'Aquesta setmana',
			dates : function()
			{
				var start = moment().day(1).toDate();
				var end = moment().toDate();
				return [start,end];
			}
		},
		//if only return an array of one date, it will display the month which containing the date. and it will not select any date range
		{
			name: 'Aquest mes',
			dates : function()
			{
				//move calendars to show this date's month and next month
				var start = moment().startOf('month').toDate();
				var end = moment().toDate();
				return [start,end];
			}
		},
		//if return an array of two dates, it will select the date range between the two dates
		{
			name: 'Aquest any',
			dates : function()
			{
				var start = moment().startOf('year').toDate();
				var end = moment().toDate();
				return [start,end];
			}
		},
	]
			
}).bind('datepicker-change',function(event,obj){
//	console.log(obj);
//	console.log(event);
//	console.log('after change');
	event.stopPropagation();
	return false;
}).bind('datepicker-close',function()
{
	/* This event will be triggered before date range picker close animation */
//	console.log('before close');
}).bind('datepicker-closed',function()
{
	/* This event will be triggered after date range picker close animation */
//	console.log('after closed');
}).bind('datepicker-apply',function(event,obj)
{
	/* This event will be triggered when user clicks on the apply button */
//	console.log(obj);
//	console.log('after apply');
});
}
$('.custom-shortcut').on('click', function(e){
	e.preventDefault();
	return false;
});

//chosen
$('.houdiniForm .chzn-select').select2();

$.fn.raty.defaults.path = '/media/img';
$.fn.raty.defaults.cancel = false;

//valoracio
$('.houdiniForm .scoreField').each(function() {
    'use strict';
    var field = $(this);
    var id = '#' + field.attr('id');
    var score = $('<div></div>');
    score.raty({
        half: true,
        hints: ['', '', '', '', ''],
        score: function() {
            return field.val();
        },
        targetScore: id
    });
    field.hide();
    field.after(score);
});

//select de dnis
$('.houdiniForm .dninifnie').each(function() {
    'use strict';
    $(this).find('select').on('change', function() {
        var value = $(this).val();
        var input = $(this).closest('div.row').find('input');

        if (value === 'DNI') {
            input.rules('add', {
                dni: true,
                cifES: false,
                nieES: false
            });
        } else if (value === 'CIF') {
            input.rules('add', {
                dni: false,
                cifES: true,
                nieES: false
            });
        } else if (value === 'NIE') {
            input.rules('add', {
                dni: false,
                cifES: false,
                nieES: true
            });
        }
    });
});
